import 'react-app-polyfill/stable';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'core-js/actual/promise/finally';
import { createBaseGainsightProvider } from '@rsos/capstone';
import '@rsos/capstone/src/overridePublicPath';
import ErrorBoundary from '@rsos/components/capstone/ErrorBoundary';
import Layout from '@rsos/components/capstone/Layout';
import { FlagProvider } from '@rsos/flags';
import { gspx } from '@rsos/gainsight';
import { captureExceptionWithScope } from '@rsos/utils/sentry';
import Main from './app/Main';
import { store, persistor } from './app/store';
import './styles/global.scss';

// Every admin section this app owns. Drives sidebar active-state in Layout.
const APP_PATHS = [
  '/admin/text-from-911',
  '/admin/messaging',
  '/admin/settings',
  '/admin/notifications',
  '/admin/data-source',
  '/admin/keywords',
  '/admin/alerts-routing',
  '/admin/responders',
  '/admin/share-and-chat',
  '/admin/peer-agencies',
  '/admin/landing-zones',
  '/admin/access',
  '/admin/integrations',
  '/admin/psap',
];

const dataProvider = {
  ...createBaseGainsightProvider(store),
  // The admin app doesn't handle call data.
  getSelectedCallData: () => null,
};
gspx.initialize(dataProvider, {
  captureError: captureExceptionWithScope,
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root was not found');
}
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <FlagProvider>
      <BrowserRouter>
        <Layout appPaths={APP_PATHS} persistor={persistor}>
          <ErrorBoundary>
            <Main />
          </ErrorBoundary>
        </Layout>
      </BrowserRouter>
    </FlagProvider>
  </Provider>,
);
